import { useState } from "react"
import MyModal from "../MyModal"
import { toast } from "react-toastify"
import {
    startTsServer,
    restartTsServer,
    stopTsServer,
    extendServer,
    activateTsServer,
    suspendTsServer,
    deleteTsServer,
} from "../../services/serverApis"
import EditServerModal from "./EditServerModal"
import { useAuth } from "../../lib/useAuth"
import BackupServerModal from "./BackupServerModal"

const ServerMoreModal = ({ server }) => {
    const { user } = useAuth()
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <button onClick={toggleModal}>
                <img className="w-[20px] h-[20px]" src="assets/icons/gear-complex.svg" />
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="800px" height="500px">
                <div className="grid grid-cols-3">
                    <div className="col-span-2 mt-5 mr-5 ml-5   ">
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>پسورد کوئری</a>
                            <a className="float-left text-blue-400">{server.query_password}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>مالک</a>
                            <a className="float-left text-blue-400">{server.author}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>اسلات</a>
                            <a className="float-left text-blue-400">{server.slots}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>ورژن</a>
                            <a className="float-left text-blue-400">{server.version}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ ساخت</a>
                            <a className="float-left text-blue-400">{server.crtString}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تاریخ انقضا</a>
                            <a className="float-left text-blue-400">{server.expString ? server.expString : "دائمی"}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>پکیج</a>
                            <a className="float-left text-blue-400">{server.package_name}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>ساب دامین</a>
                            <a className="float-left text-blue-400">{server.fullDomainName}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>تمدید خودکار</a>
                            <a className="float-left text-blue-400">{server.autorenew ? "فعال" : "غیرفعال"}</a>
                        </li>

                        <li className="py-2 border-b-2 border-t-2 border-slate-700 relative block">
                            <a>توضیحات</a>
                            <a className="float-left text-blue-400">{server.info}</a>
                        </li>
                    </div>
                    <div className="col-span-1 flex flex-col ">
                        <EditServerModal server={server} />

                        <a
                            className="flex gap-3 justify-center border text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-slate-600 focus:outline-none focus:shadow-outline"
                            style={{ backgroundColor: "#3B82F6" }}
                            href={`/manage-server?serverId=${server.id}`}
                            target="_blank"
                        >
                            <img src="assets/icons/server.svg" width="20px" height="20px" />
                            <p>مشاهده</p>
                        </a>
                        <BackupServerModal server={server} />
                        <button
                            onClick={() => {
                                toast.promise(extendServer(server.id), {
                                    pending: "در حال تمدید سرور",
                                    success: "با موفقیت تمدید شد",
                                })
                            }}
                            style={{ backgroundColor: "#22C55E" }}
                            className="flex justify-center gap-2 border text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            <p>تمدید</p>
                        </button>

                        {server.status == "offline" ? (
                            <button
                                onClick={() => {
                                    if (server.state == "suspended") {
                                        toast.error("سرور غیرفعال میباشد")
                                        return
                                    }
                                    toast
                                        .promise(startTsServer(server.id), {
                                            pending: "در حال روشن کردن سرور",
                                            success: "روشن شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center gap-2 border styled-button success text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none  focus:outline-none focus:shadow-outline"
                            >
                                <img src="assets/icons/play.svg" width="20px" height="20px" />
                                روشن
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(stopTsServer(server.id), {
                                            pending: "در حال خاموش کردن سرور",
                                            success: "خاموش شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                style={{ backgroundColor: "#DC2626" }}
                                className="flex justify-center  gap-2 styled-button border danger text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none  focus:outline-none focus:shadow-outline"
                            >
                                <img src="assets/icons/power-off.svg" width="20px" height="20px" />
                                خاموش
                            </button>
                        )}
                        <button
                            onClick={() => {
                                if (server.state == "suspended") {
                                    toast.error("سرور غیرفعال میباشد")
                                    return
                                }
                                toast
                                    .promise(restartTsServer(server.id), {
                                        pending: "در حال ریستارت کردن سرور",
                                        success: "ریستارت شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            style={{ backgroundColor: "#6366F1" }}
                            className="flex justify-center gap-2 styled-button border  text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none  focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/repeat.svg" width="20px" height="20px" />
                            ریستارت
                        </button>
                        {server.state == "suspended" ? (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(activateTsServer(server.id), {
                                            pending: "در حال فعال کردن سرور",
                                            success: "فعال شد",
                                        })

                                        .catch((err) => {
                                            if (err?.response?.data == "Expired") {
                                                toast.error("منقضی شده است")
                                            }
                                        })
                                }}
                                className="flex justify-center border  bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                    <rect
                                        x="10.5"
                                        style={{ fill: "#f4f4f5", backgroundColor: "white" }}
                                        width="6"
                                        height="30"
                                    />
                                </svg>
                                فعال کردن
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(suspendTsServer(server.id), {
                                            pending: "در حال غیرفعال کردن سرور",
                                            success: "غیرفعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                style={{ backgroundColor: "#F59E0B" }}
                                className="flex justify-center border  text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                            >
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#f4f4f5" }} width="6" height="30" />
                                </svg>
                                غیرفعال کردن
                            </button>
                        )}

                        <button
                            onClick={() => {
                                toggleModal()
                                toast
                                    .promise(deleteTsServer(server.id), {
                                        pending: "در حال حذف کردن سرور",
                                        success: "حذف شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            style={{ backgroundColor: "#EF4444" }}
                            className="flex justify-center gap-2 styled-button danger border text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            <img src="assets/icons/trash-can.svg" width="20px" height="20px" />
                            حذف
                        </button>
                    </div>
                </div>
            </MyModal>
        </>
    )
}

export default ServerMoreModal
